<template>
    <label class="switch">
        <input
            type="checkbox"
            class="switch__checkbox"
            :checked="modelValue"
            @change="$emit('update:modelValue', $event.target.checked)"
        />
        <span class="switch__slider"></span>
        <slot></slot>
    </label>
</template>

<script>
export default {
    name: 'Switcher',
    emits: ['update:modelValue'],
    props: ['modelValue']
};
</script>

<style lang="scss" src="./Switcher.scss"></style>
